'use client';

import type { ChangeEvent } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { QuantityPicker } from '../product-details';
import { type MiniPdpQuantityProps, useMiniPdpQuantity } from './model/use-mini-pdp-quantity';
import type { MiniPdpForm } from './types';

export function MiniPdpQuantity(props: MiniPdpQuantityProps) {
    const { control } = useFormContext<MiniPdpForm>();
    const { items, disabled, fulfilmentMethod, selectedSku, shouldRender } = useMiniPdpQuantity(props);
    const { field } = useController({ name: 'quantity', control });

    if (!shouldRender) return null;

    return (
        <QuantityPicker
            items={items}
            disabled={disabled}
            value={String(field.value)}
            key={`${selectedSku}-${fulfilmentMethod}`}
            name={field.name}
            onChange={(event: ChangeEvent<HTMLSelectElement>) => field.onChange(Number(event.target.value))}
            onBlur={field.onBlur}
            testId="mini-pdp-quantity-selector"
        />
    );
}
